import { analiticaInstance } from 'shared/analitica'

export default analiticaInstance.eventFactory('Balance home card', {
  balanceHomeCard: {
    /**
     * @analitica when an error occurs during the balance request
     */

    requestError: () => ({
      label: 'home web - balance error state viewed'
    })
  }
})
